import React, { useEffect, useState } from "react";
import { object, string, array } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import LinkTag from "../../molecules/link-tag";
import Headline from "../../atoms/headline";
import CardImage from "../../atoms/cardimage";
import SeeMore from "../../atoms/see-more";
import CustomStoryCard4 from "../../molecules/custom-story-card4";
import CustomStoryCard5 from "../../molecules/custom-story-card5";
import SixStoryMixedDesignMobile from "../six-story-mixed-design-mobile";
import BigWithSmallStoryMobile from "../big-with-small-story-mobile";
import { Standard300x260Container, Standard337x280Container } from "../../rows/ad-free";

import { getAllSectionsStories, getCollectionSlug } from "../../utils/utils";
import { getFitStories } from "../../helper/api";

import "./sixStoryWithSeeMoreAd.m.css";

const SixStoryWithSeeMoreAd = ({ collection, publisherName, sections, pageType, sectionName, fitUrl }) => {
  if (!(collection && collection.items)) {
    return null;
  }

  const [storiesArray, setStories] = useState(collection.items);
  const [isExternalStory, setExternalStory] = useState(false);
  const [externalSlug, setExternalSlug] = useState("");

  useEffect(() => {
    if (collection.template === "external-collection") {
      const slug = get(collection, ["metadata", "external-collection-slug"], "home");
      getFitStories(slug).then((data) => {
        setStories(data.items);
        setExternalSlug(`${fitUrl}/${slug}`);
        setExternalStory(true);
      });
    }
  }, []);

  const stories = getAllSectionsStories(sectionName, collection, storiesArray, 6);

  if (!(stories && stories.length)) {
    return null;
  }

  // Can be enabled when required
  // const navigationView = () => (
  //   <Link href={getCollectionSlug(collection, sections)} styleName="collection-link">
  //     {translate(publisherName, "see_more")}
  //   </Link>
  // );

  const getCollectionName = () => {
    // If home page return the actual name
    if (pageType === "home-page") {
      return collection.name;
    }

    // If section page and collection.template is 'top-story'
    // then return the section name (as a fallback return collection name)
    if (collection.template === "top-story") {
      return sectionName || collection.name;
    }

    // default return collection.name
    return collection.name;
  };

  const getHeaderView = () => (
    <div styleName="header-wrapper">
      <div styleName="heading-more" id={collection.template === "top-story" && "top-story-heading-more"}>
        <LinkTag
          href={isExternalStory ? externalSlug : getCollectionSlug(collection, sections)}
          isExternalStory={isExternalStory}
        >
          <Headline text={getCollectionName()} headerType={9} />
        </LinkTag>
      </div>
      {collection.summary && <div styleName="summary">{collection.summary}</div>}
    </div>
  );

  const [firstStory, secondStory, ...remainingStories] = stories;

  return (
    <div styleName="wrapper" className="container" id={collection.slug}>
      <div styleName={sectionName === "All Sections" ? "desktop-content" : ""}>{getHeaderView()}</div>

      <div styleName="desktop-content">
        <div styleName="row-1">
          <LinkTag href={firstStory.url} isExternalStory={isExternalStory}>
            <CardImage
              story={firstStory}
              aspectRatio={[3, 2]}
              imageType="image3x2"
              widths={[430]}
              eager={true}
              showHeadline={true}
              showStoryTypeIcon
            />
          </LinkTag>

          {secondStory && <CustomStoryCard4 story={secondStory} isExternalStory={isExternalStory} />}

          <div styleName="desktop-ad">
            <Standard300x260Container id="rightATF" />
          </div>
        </div>
        <div styleName="row-2">
          {remainingStories.map((item, index) => (
            <CustomStoryCard5 story={item} key={index} isExternalStory={isExternalStory} />
          ))}
        </div>
      </div>
      <div styleName={sectionName !== "All Sections" && "none"}>
        <div styleName={sectionName === "All Sections" ? "all-sections-mobile" : "desktop-content"}>
          <BigWithSmallStoryMobile collection={collection} />
        </div>
      </div>

      <div styleName={sectionName === "All Sections" ? "desktop-content" : "mobile"}>
        <SixStoryMixedDesignMobile list={stories} isExternalStory={isExternalStory} />

        <SeeMore
          isExternalStory={isExternalStory}
          externalSlug={externalSlug}
          collection={collection}
          sections={sections}
          publisherName={publisherName}
        />

        <div styleName="mobile-ad">
          <Standard337x280Container id="mid2" type="mobile" />
        </div>
      </div>
    </div>
  );
};

SixStoryWithSeeMoreAd.propTypes = {
  collection: object.isRequired,
  publisherName: string,
  sections: array,
  pageType: string,
  fitUrl: string,
  sectionName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
  sections: get(state, ["qt", "config", "sections"], []),
  currentPath: get(state, ["qt", "currentPath"], null),
  pageType: get(state, ["qt", "pageType"], null),
  sectionName: get(state, ["qt", "data", "collection", "name"], ""),
  fitUrl: get(state, ["qt", "config", "publisher-attributes", "fit_page_url"], null),
});

export default connect(mapStateToProps, null)(SixStoryWithSeeMoreAd);
